var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTableIcons(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 7.91307V9.86959C0 10.2299 0.291914 10.5218 0.652187 10.5218H1.30437V16.3913C1.30437 16.7516 1.59629 17.0435 1.95656 17.0435H4.56527C4.92555 17.0435 5.21746 16.7516 5.21746 16.3913V10.5218H14.7827V16.3913C14.7827 16.7516 15.0746 17.0435 15.4349 17.0435H18.0436C18.4039 17.0435 18.6958 16.7516 18.6958 16.3913V10.5218H19.348C19.7082 10.5218 20.0002 10.2299 20.0002 9.86959V7.91307H0ZM17.3312 1.33549C17.279 1.22237 17.1955 1.12656 17.0906 1.0594C16.9857 0.992245 16.8637 0.956551 16.7391 0.956543H3.26086C3.13628 0.956556 3.01432 0.992252 2.90939 1.05941C2.80447 1.12656 2.72097 1.22237 2.66879 1.33549L0.235 6.60873H19.765L17.3312 1.33549Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTableIcons);
export default __webpack_public_path__ + "static/media/table-icons.071f30e0b7eebdb350d9513317305ec8.svg";
export { ForwardRef as ReactComponent };